import { withRouter } from "react-router";
import React, { Component } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import { compose } from "recompose";
import appLogo from "../../../assets/logo/agronomist_a.svg";
import withLayout from "../../../services/hoc/withLayout";
import { Footer, Metadata, NavigationBar } from "../../common/index";
import Sections from "../../common/Sections";
import "./LandingPage.scss";
import MarketPricesWidget from "../../common/MarketPricesWidget/MarketPricesWidget";
import Weather from "../../blocks/WeatherWidget/Weather";
import Banners from "../../blocks/Section/Banners";
import BannersCarousel from "../../blocks/Section/BannersCarousel";
import { RegisterBaner } from "../../common/Banners/Banners";
import ArticlesSectionCarousel from "../../blocks/Section/ArticlesSectionCarousel";
import { PressSectionCarousel } from "../../blocks/Section/PressSectionCarousel";
import { MultimediaSectionCarousel } from "../../blocks/Section/MultimediaSectionCarousel";
import { EventsSectionCarousel } from "../../blocks/Section/EventsSectionCarousel";
import ToolsCarousel from "../../blocks/Section/ToolsCarousel";
import ShowOffCarousel from "../../blocks/Section/ShowOffCarousel";
import MakroSection from "../../blocks/Section/MakroSection";

export const MobileSpecialContainer = props => {
  if (window.innerWidth < 576) {
    return <>{props.children}</>;
  }
  return <Container>{props.children}</Container>;
};

export const LandingPageContent = () => {
  const { i18n } = useTranslation();

  return (
    <>
      <Container>
        <MarketPricesWidget />
      </Container>
      <MobileSpecialContainer>
        <Sections.ArticlesFeaturedSection />
      </MobileSpecialContainer>
      <Container>
        <Weather />
      </Container>
      <BannersCarousel background="dark" slidesPerView={3} articles={Banners} />
      <ArticlesSectionCarousel background="white" isCarousel={false} />
      <MakroSection background="dark" />
      <PressSectionCarousel background="white" isCarousel={false} />
      <MultimediaSectionCarousel background="dark" />
      <ToolsCarousel background="white" slidesPerView={4} />
      <EventsSectionCarousel background="dark" slidesPerView={3} />
      <RegisterBaner i18n={i18n} />
      {/* <FooterPosts /> */}
    </>
  );
};

class LandingPage extends Component {
  render() {
    const { currentWidth, t } = this.props;

    return (
      <Container fluid>
        <Metadata
          photo={appLogo}
          name={t("metaInfo:landingPage.title")}
          description={t("metaInfo:landingPage.description")}
          noTitleSufix
        />
        <NavigationBar />
        <LandingPageContent />
        <Footer windowWidth={currentWidth} />
      </Container>
    );
  }
}

export default compose(
  withRouter,
  withTranslation([
    "landingPage",
    "tools",
    "globals",
    "metaInfo",
    "navigation",
    "averagePrices",
    "widgets",
    "articlesMeta",
  ])
)(withLayout(LandingPage));
